import React from "react";

const Info = ({ onClick, present, ...rest }) => (
    <nav className={ [`info`, `${present ? `info--present` : `info--missing`}`].join( ` ` ) } >
        <button tabIndex="0" className={ `info-button` }  onClick={ onClick } >
        <svg id="info" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.33 28.57">
            <g>
                <rect x="1.66" y="7.15" width="1" height="21.42"/>
                <path d="M2.5,6A2.16,2.16,0,1,1,4.66,3.88,2.16,2.16,0,0,1,2.5,6Zm0-3.32A1.16,1.16,0,1,0,3.66,3.88,1.16,1.16,0,0,0,2.5,2.72Z" transform="translate(-0.34 -1.72)"/>
            </g>
        </svg>
        </button>
    </nav>
)

export default Info